[
  {
    "label": "AKO Capital",
    "name": "AKO CAPITAL LLP",
    "cik": "0001376879",
    "homepage": "https://www.akocapital.com/",
    "category": "quality",
    "region": "europe"
  },
  {
    "label": "Akre Capital Management",
    "name": "AKRE CAPITAL MANAGEMENT LLC",
    "cik": "0001112520",
    "homepage": "https://www.akrecapital.com/",
    "category": "quality",
    "region": "us"
  },
  {
    "label": "Atlantic Investment Management",
    "name": "ATLANTIC INVESTMENT MANAGEMENT INC",
    "cik": "0001063296",
    "people": [
      "Alex Roepers"
    ],
    "homepage": "http://www.atlanticinvestment.net/",
    "category": "activist",
    "region": "us"
  },
  {
    "label": "Arlington Value Capital",
    "name": "ARLINGTON VALUE CAPITAL, LLC",
    "cik": "0001568820",
    "people": [
      "Allan Mecham"
    ],
    "homepage": null,
    "category": "value",
    "region": "us"
  },
  {
    "label": "AltaRock Partners",
    "name": "ALTAROCK PARTNERS LP",
    "cik": "0001631014",
    "homepage": null,
    "category": "value",
    "region": "us"
  },
  {
    "label": "Appaloosa Management",
    "name": "APPALOOSA LP",
    "cik": "0001656456",
    "people": [
      "David Tepper"
    ],
    "homepage": null,
    "category": "value",
    "region": "us"
  },
  {
    "label": "AQR Capital Management",
    "name": "AQR CAPITAL MANAGEMENT LLC",
    "cik": "0001167557",
    "homepage": "https://www.aqr.com/",
    "category": "quant",
    "region": "us"
  },
  {
    "label": "Baillie Gifford",
    "name": "BAILLIE GIFFORD & CO",
    "cik": "0001088875",
    "homepage": "https://www.bailliegifford.com/",
    "category": "growth",
    "region": "europe"
  },
  {
    "label": "Baupost Group",
    "name": "BAUPOST GROUP LLC",
    "cik": "0001061768",
    "people": [
      "Seth Klarman"
    ],
    "homepage": "https://www.baupost.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Gates Foundation Trust",
    "name": "GATES FOUNDATION TRUST",
    "cik": "0001166559",
    "homepage": "https://cascadeassetmanagement.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Pershing Square",
    "name": "PERSHING SQUARE CAPITAL MANAGEMENT L.P.",
    "cik": "0001336528",
    "people": [
      "Bill Ackman"
    ],
    "homepage": "https://pershingsquareholdings.com/",
    "category": "activist",
    "region": "us"
  },
  {
    "label": "Miller Value Partners",
    "name": "MILLER VALUE PARTNERS LLC",
    "cik": "0001135778",
    "people": [
      "Bill Miller"
    ],
    "homepage": "https://millervalue.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Harris Associates",
    "name": "HARRIS ASSOCIATES L P",
    "cik": "0000813917",
    "people": [
      "Bill Nygren"
    ],
    "homepage": "https://harrisassoc.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Eagle Capital",
    "name": "EAGLE CAPITAL MANAGEMENT LLC",
    "cik": "0000945631",
    "people": [
      "Boykin Curry"
    ],
    "homepage": "https://www.eaglecap.com/",
    "category": "quality",
    "region": "us"
  },
  {
    "label": "Brandes Investment Partners",
    "name": "BRANDES INVESTMENT PARTNERS, LP",
    "cik": "0001015079",
    "homepage": "https://www.brandes.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Brave Warrior Advisors",
    "name": "BRAVE WARRIOR ADVISORS, LLC",
    "cik": "0001553733",
    "homepage": null,
    "category": "value",
    "region": "us"
  },
  {
    "label": "Brookfield Corp",
    "name": "BROOKFIELD CORP /ON/",
    "cik": "0001001085",
    "homepage": "https://www.brookfield.com/",
    "category": "value",
    "region": "canada"
  },
  {
    "label": "Fairholme Capital",
    "name": "FAIRHOLME CAPITAL MANAGEMENT LLC",
    "cik": "0001056831",
    "people": [
      "Bruce Berkowitz"
    ],
    "homepage": "https://www.fairholmecapital.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Oakcliff Capital",
    "name": "OAKCLIFF CAPITAL PARTNERS LP",
    "cik": "0001657335",
    "people": [
      "Bryan Lawrence"
    ],
    "homepage": "https://oakcliffcapital.com/",
    "category": "quality",
    "region": "us"
  },
  {
    "label": "Carl Icahn",
    "name": "ICAHN CARL C",
    "cik": "0000921669",
    "homepage": "https://www.ielp.com/",
    "category": "activist",
    "region": "us"
  },
  {
    "label": "Ariel Investments",
    "name": "ARIEL INVESTMENTS LLC",
    "cik": "0000936753",
    "people": [
      "Charles Bobrinskoy"
    ],
    "homepage": "https://www.arielinvestments.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Tiger Global Management",
    "name": "TIGER GLOBAL MANAGEMENT LLC",
    "cik": "0001167483",
    "people": [
      "Chase Coleman"
    ],
    "homepage": "https://www.tigerglobal.com/",
    "category": "growth",
    "region": "us"
  },
  {
    "label": "Check Capital Management",
    "name": "CHECK CAPITAL MANAGEMENT INC/CA",
    "cik": "0001032814",
    "homepage": "https://checkcapital.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Davis Advisors",
    "name": "DAVIS SELECTED ADVISERS",
    "cik": "0001036325",
    "people": [
      "Chris Davis"
    ],
    "homepage": "https://www.davisadvisors.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "TCI Fund Management",
    "name": "TCI FUND MANAGEMENT LTD",
    "cik": "0001647251",
    "people": [
      "Chris Hohn"
    ],
    "homepage": "https://www.tcifund.com/",
    "category": "activist",
    "region": "europe"
  },
  {
    "label": "Semper Augustus",
    "name": "SEMPER AUGUSTUS INVESTMENTS GROUP LLC",
    "cik": "0001115373",
    "people": [
      "Christopher Bloomstran"
    ],
    "homepage": "https://www.semperaugustus.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Royce Investment Partners",
    "name": "ROYCE & ASSOCIATES LP",
    "cik": "0000906304",
    "people": [
      "Chuck Royce"
    ],
    "homepage": "https://www.royceinvest.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "CAS Investment Partners",
    "name": "CAS INVESTMENT PARTNERS LLC",
    "cik": "0001697591",
    "people": [
      "Clifford Sosin"
    ],
    "homepage": "https://www.casinvestmentpartners.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Third Point",
    "name": "THIRD POINT LLC",
    "cik": "0001040273",
    "people": [
      "Daniel Loeb"
    ],
    "homepage": "https://www.thirdpoint.com/",
    "category": "activist",
    "region": "us"
  },
  {
    "label": "Abrams Capital",
    "name": "ABRAMS CAPITAL MANAGEMENT L.P.",
    "cik": "0001358706",
    "people": [
      "David Abrams"
    ],
    "homepage": "https://www.abramscapital.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Greenlight Capital",
    "name": "GREENLIGHT CAPITAL INC",
    "cik": "0001079114",
    "people": [
      "David Einhorn"
    ],
    "homepage": "https://www.greenlightcapital.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Matrix Asset Advisors",
    "name": "MATRIX ASSET ADVISORS INC/NY",
    "cik": "0001016287",
    "people": [
      "David Katz"
    ],
    "homepage": "https://matrixassetadvisors.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Wedgewood Partners",
    "name": "WEDGEWOOD PARTNERS INC",
    "cik": "0000859804",
    "people": [
      "David Rolfe"
    ],
    "homepage": "https://wedgewoodpartners.com/",
    "category": "quality",
    "region": "us"
  },
  {
    "label": "ShawSpring Partners",
    "name": "SHAWSPRING PARTNERS LLC",
    "cik": "0001766908",
    "people": [
      "Dennis Hong"
    ],
    "homepage": "https://shawspring.com/",
    "category": "quality",
    "region": "us"
  },
  {
    "label": "Dodge & Cox",
    "name": "DODGE & COX",
    "cik": "0000200217",
    "homepage": "https://www.dodgeandcox.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Yacktman Asset Management",
    "name": "YACKTMAN ASSET MANAGEMENT LP",
    "cik": "0000905567",
    "people": [
      "Donald Yacktman"
    ],
    "homepage": "https://yacktman.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "H&H International Investment",
    "name": "H&H INTERNATIONAL INVESTMENT LLC",
    "cik": "0001759760",
    "people": [
      "Duan Yongping"
    ],
    "homepage": null,
    "category": "value",
    "region": "us"
  },
  {
    "label": "Greenhaven Associates",
    "name": "GREENHAVEN ASSOCIATES INC",
    "cik": "0000846222",
    "people": [
      "Edgar Wachenheim"
    ],
    "homepage": null,
    "category": "value",
    "region": "us"
  },
  {
    "label": "First Eagle Investment Management",
    "name": "FIRST EAGLE INVESTMENT MANAGEMENT, LLC",
    "cik": "0001325447",
    "homepage": "https://www.firsteagle.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "First Manhattan Co.",
    "name": "FIRST MANHATTAN CO. LLC.",
    "cik": "0000728083",
    "homepage": "https://firstmanhattan.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "First Pacific Advisors",
    "name": "FIRST PACIFIC ADVISORS LP",
    "cik": "0001377581",
    "people": [
      "Robert Rodriguez",
      "Steven Romick"
    ],
    "homepage": "https://fpa.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "FPA Queens Road Small Cap Value Fund",
    "name": "BRAGG FINANCIAL ADVISORS, INC",
    "cik": "0001327055",
    "homepage": "https://fpa.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Chou Associates",
    "name": "CHOU ASSOCIATES MANAGEMENT INC.",
    "cik": "0001389403",
    "people": [
      "Francis Chou"
    ],
    "homepage": "https://choufunds.com/",
    "category": "value",
    "region": "canada"
  },
  {
    "label": "Giverny Capital",
    "name": "GIVERNY CAPITAL INC",
    "cik": "0001641864",
    "people": [
      "Francois Rochon"
    ],
    "homepage": "https://www.givernycam.com/",
    "category": "quality",
    "region": "canada"
  },
  {
    "label": "Gardner Russo & Quinn",
    "name": "GARDNER RUSSO & QUINN LLC",
    "cik": "0000860643",
    "people": [
      "Thomas Russo"
    ],
    "homepage": null,
    "category": "quality",
    "region": "us"
  },
  {
    "label": "Engaged Capital",
    "name": "ENGAGED CAPITAL LLC",
    "cik": "0001559771",
    "people": [
      "Glenn Welling"
    ],
    "homepage": "https://engagedcapital.com/",
    "category": "activist",
    "region": "us"
  },
  {
    "label": "GMO",
    "name": "GRANTHAM, MAYO, VAN OTTERLOO & CO. LLC",
    "cik": "0001352662",
    "people": [
      "Jeremy Grantham"
    ],
    "homepage": "https://www.gmo.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Conifer Management",
    "name": "CONIFER MANAGEMENT L.L.C.",
    "cik": "0001773994",
    "people": [
      "Greg Alexander"
    ],
    "homepage": null,
    "category": "value",
    "region": "us"
  },
  {
    "label": "Aquamarine Capital",
    "name": "AQUAMARINE CAPITAL MANAGEMENT, LLC",
    "cik": "0001404599",
    "people": [
      "Guy Spier"
    ],
    "homepage": "https://www.aquamarinefund.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Sound Shore",
    "name": "SOUND SHORE MANAGEMENT INC",
    "cik": "0000820124",
    "people": [
      "Harry Burn"
    ],
    "homepage": "https://soundshorefund.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Hillman Value Fund",
    "name": "HILLMAN CAPITAL MANAGEMENT, INC.",
    "cik": "0001314620",
    "homepage": "https://www.hcmfunds.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Himalaya Capital",
    "name": "HIMALAYA CAPITAL MANAGEMENT LLC",
    "cik": "0001709323",
    "people": [
      "Li Lu"
    ],
    "homepage": "https://www.himcap.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Oaktree Capital",
    "name": "OAKTREE CAPITAL GROUP HOLDINGS GP, LLC",
    "cik": "0001403525",
    "people": [
      "Howard Marks"
    ],
    "homepage": "https://www.oaktreecapital.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Hound Partners",
    "name": "HOUND PARTNERS LP",
    "cik": "0001328137",
    "homepage": null,
    "category": "value",
    "region": "us"
  },
  {
    "label": "Jensen Investment Management",
    "name": "JENSEN INVESTMENT MANAGEMENT INC",
    "cik": "0001106129",
    "homepage": "https://www.jenseninvestment.com/",
    "category": "quality",
    "region": "us"
  },
  {
    "label": "Gotham Asset Management",
    "name": "GOTHAM ASSET MANAGEMENT LLC",
    "cik": "0001510387",
    "people": [
      "Joel Greenblatt"
    ],
    "homepage": "https://www.gothamfunds.com/",
    "category": "quant",
    "region": "us"
  },
  {
    "label": "Egerton Capital",
    "name": "EGERTON CAPITAL (UK) LLP",
    "cik": "0001581811",
    "people": [
      "John Armitage"
    ],
    "homepage": "https://www.egertoncapital.com/",
    "category": "quality",
    "region": "europe"
  },
  {
    "label": "Greenlea Lane Capital",
    "name": "GREENLEA LANE CAPITAL MANAGEMENT LLC",
    "cik": "0001766504",
    "people": [
      "Josh Tarasoff"
    ],
    "homepage": "https://www.greenlealane.com/",
    "category": "quality",
    "region": "us"
  },
  {
    "label": "Kahn Brothers Group",
    "name": "KAHN BROTHERS ADVISORS LLC",
    "cik": "0001039565",
    "homepage": "https://kahnbrothers.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Fisher Investments",
    "name": "FISHER ASSET MANAGEMENT, LLC",
    "cik": "0000850529",
    "people": [
      "Ken Fisher"
    ],
    "homepage": "https://www.fisherinvestments.com/",
    "category": "growth",
    "region": "us"
  },
  {
    "label": "Maverick Capital",
    "name": "MAVERICK CAPITAL LTD",
    "cik": "0000934639",
    "people": [
      "Lee Ainslie"
    ],
    "homepage": "https://www.maverickcap.com/",
    "category": "growth",
    "region": "us"
  },
  {
    "label": "Omega Advisors",
    "name": "COOPERMAN LEON G",
    "cik": "0000898382",
    "people": [
      "Leon Cooperman"
    ],
    "homepage": "https://www.omegaadvisers.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Lindsell Train",
    "name": "LINDSELL TRAIN LTD",
    "cik": "0001484150",
    "homepage": "https://www.lindselltrain.com/",
    "category": "quality",
    "region": "europe"
  },
  {
    "label": "Longleaf Partners",
    "name": "SOUTHEASTERN ASSET MANAGEMENT INC/TN",
    "cik": "0000807985",
    "people": [
      "Mason Hawkins"
    ],
    "homepage": "https://southeasternasset.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "SQ Advisors",
    "name": "SQ ADVISORS, LLC",
    "cik": "0001534380",
    "people": [
      "Lou Simpson"
    ],
    "homepage": null,
    "category": "value",
    "region": "us"
  },
  {
    "label": "Mairs & Power",
    "name": "MAIRS & POWER INC",
    "cik": "0001070134",
    "homepage": "https://www.mairsandpower.com/",
    "category": "quality",
    "region": "us"
  },
  {
    "label": "Makaira Partners",
    "name": "MAKAIRA PARTNERS LLC",
    "cik": "0001540866",
    "people": [
      "Tom Bancroft"
    ],
    "homepage": "https://makairapartners.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Markel Group",
    "name": "MARKEL GROUP INC",
    "cik": "0001096343",
    "people": [
      "Thomas Gayner"
    ],
    "homepage": "https://www.mklgroup.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Meridian Contrarian Fund",
    "name": "ARROWMARK COLORADO HOLDINGS LLC",
    "cik": "0001483859",
    "homepage": "https://www.arrowmarkpartners.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Scion Asset Management",
    "name": "SCION ASSET MANAGEMENT LLC",
    "cik": "0001649339",
    "people": [
      "Michael Burry"
    ],
    "homepage": "https://www.scionasset.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Pabrai Investments",
    "name": "DALAL STREET LLC",
    "cik": "0001549575",
    "people": [
      "Mohnish Pabrai"
    ],
    "homepage": "https://dhandhofunds.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Trian Fund Management",
    "name": "TRIAN FUND MANAGEMENT L.P.",
    "cik": "0001345471",
    "people": [
      "Nelson Peltz"
    ],
    "homepage": "https://trianpartners.com/",
    "category": "activist",
    "region": "us"
  },
  {
    "label": "Punch Card Management",
    "name": "PUNCH CARD MANAGEMENT L.P.",
    "cik": "0001631664",
    "people": [
      "Norbert Lou"
    ],
    "homepage": "https://punchcardcapital.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Dorsey Asset Management",
    "name": "DORSEY ASSET MANAGEMENT LLC",
    "cik": "0001671657",
    "people": [
      "Pat Dorsey"
    ],
    "homepage": "https://dorseyasset.com/",
    "category": "quality",
    "region": "us"
  },
  {
    "label": "Patient Capital Management",
    "name": "PATIENT CAPITAL MANAGEMENT LLC",
    "cik": "0001854794",
    "people": [
      "Samantha McLemore"
    ],
    "homepage": "https://patientcapitalmanagement.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Polen Capital Management",
    "name": "POLEN CAPITAL MANAGEMENT LLC",
    "cik": "0001034524",
    "homepage": "https://www.polencapital.com/",
    "category": "quality",
    "region": "us"
  },
  {
    "label": "Fairfax Financial Holdings",
    "name": "FAIRFAX FINANCIAL HOLDINGS LTD/ CAN",
    "cik": "0000915191",
    "people": [
      "Prem Watsa"
    ],
    "homepage": "https://www.fairfax.ca/",
    "category": "value",
    "region": "canada"
  },
  {
    "label": "Pzena Investment Management",
    "name": "PZENA INVESTMENT MANAGEMENT LLC",
    "cik": "0001027796",
    "homepage": "https://www.pzena.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Olstein Capital Management",
    "name": "OLSTEIN CAPITAL MANAGEMENT L.P.",
    "cik": "0000947996",
    "people": [
      "Robert Olstein"
    ],
    "homepage": "https://www.olsteinfunds.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "RV Capital",
    "name": "RV CAPITAL AG",
    "cik": "0001766596",
    "people": [
      "Robert Vinall"
    ],
    "homepage": "https://www.rvcapital.ch/",
    "category": "quality",
    "region": "europe"
  },
  {
    "label": "Sequoia Fund",
    "name": "RUANE, CUNNIFF & GOLDFARB INC",
    "cik": "0000728014",
    "people": [
      "Ruane Cunniff"
    ],
    "homepage": "https://www.sequoiafund.com/",
    "category": "quality",
    "region": "us"
  },
  {
    "label": "Causeway Capital Management",
    "name": "CAUSEWAY CAPITAL MANAGEMENT LLC",
    "cik": "0001165797",
    "people": [
      "Sarah Ketterer"
    ],
    "homepage": "https://www.causewaycap.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Lone Pine Capital",
    "name": "LONE PINE CAPITAL LLC",
    "cik": "0001061165",
    "people": [
      "Stephen Mandel"
    ],
    "homepage": "https://www.lonepinecapital.com/",
    "category": "growth",
    "region": "us"
  },
  {
    "label": "Fundsmith",
    "name": "FUNDSMITH INVESTMENT SERVICES LTD",
    "cik": "0001868537",
    "people": [
      "Terry Smith"
    ],
    "homepage": "https://www.fundsmith.co.uk/",
    "category": "quality",
    "region": "europe"
  },
  {
    "label": "Third Avenue Management",
    "name": "THIRD AVENUE MANAGEMENT LLC",
    "cik": "0001099281",
    "homepage": "https://www.thirdave.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Torray Funds",
    "name": "TORRAY INVESTMENT PARTNERS LLC",
    "cik": "0000098758",
    "homepage": "https://www.torrayfund.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Triple Frond Partners",
    "name": "TRIPLE FROND PARTNERS LLC",
    "cik": "0001454502",
    "homepage": null,
    "category": "quality",
    "region": "us"
  },
  {
    "label": "Tweedy Browne",
    "name": "TWEEDY, BROWNE CO LLC",
    "cik": "0000732905",
    "homepage": "https://www.tweedyfunds.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Valley Forge Capital Management",
    "name": "VALLEY FORGE CAPITAL MANAGEMENT, LP",
    "cik": "0001697868",
    "homepage": "https://www.valleyforgecapital.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "ValueAct Capital",
    "name": "VALUEACT CAPITAL MANAGEMENT L.P.",
    "cik": "0001351069",
    "homepage": "https://valueact.com/",
    "category": "activist",
    "region": "us"
  },
  {
    "label": "Viking Global Investors",
    "name": "VIKING GLOBAL INVESTORS LP",
    "cik": "0001103804",
    "homepage": "https://vikingglobal.com/",
    "category": "growth",
    "region": "us"
  },
  {
    "label": "Weitz Investment Management",
    "name": "WEITZ INVESTMENT MANAGEMENT INC",
    "cik": "0000883965",
    "people": [
      "Wallace Weitz"
    ],
    "homepage": "https://weitzinvestments.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Berkshire Hathaway",
    "name": "BERKSHIRE HATHAWAY INC",
    "cik": "0001067983",
    "people": [
      "Warren Buffett"
    ],
    "homepage": "https://berkshirehathaway.com/",
    "category": "value",
    "region": "us"
  },
  {
    "label": "Cantillon Capital",
    "name": "CANTILLON CAPITAL MANAGEMENT LLC",
    "cik": "0001279936",
    "people": [
      "William Von Mueffling"
    ],
    "homepage": "https://www.cantillon.com/",
    "category": "quality",
    "region": "us"
  }
]
